import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { get } from 'lodash';

import { colors } from '../../styles';
import Form from '../../components/Forms/Form';

const styles = css`
  padding: 0 0 70px;
  @media(min-width: 992px) {
    padding: 100px 0;
  }

  .ContentSection_body {
    font-weight: 300;
    font-size: 15px;
    color: ${colors.color3};
    letter-spacing: 0;
    line-height: 28px;
    @media(min-width: 992px) {
      font-size: 17px;
      color: ${colors.text};
      line-height: 30px;
    }
    b {
      font-weight: 700;
    }
    a {
      font-weight: 700;
    }
  }
  .container {
    margin: 0 auto;
  }
  .form-col-fluid {
    margin-bottom: 30px;
  }
`;

function ContentSection({ content }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row">
          <div className="col-lg-5 pr-lg-4 mt-4 mt-lg-0">
            <div className="ContentSection_body mb-5 mb-lg-0" dangerouslySetInnerHTML={SanitizeHtml(get(content, 'body_copy'))} />
          </div>
          <div className="col-lg-7 px-4">
            <Form
              formName="contactUs"
              formLabel="Contact Us"
              thankYou={get(content, 'thank_you_body')}
              fields={[
                {
                  type: 'Text',
                  label: 'First Name',
                  className: 'form-col',
                  field: 'firstName',
                  required: true,
                },
                {
                  type: 'Text',
                  label: 'Last Name',
                  className: 'form-col',
                  field: 'lastName',
                  required: true,
                },
                {
                  type: 'Email',
                  label: 'Email',
                  className: 'form-col',
                  field: 'email',
                  required: true,
                  requiredMessage: '',
                  invalidMessage: '',
                },
                {
                  type: 'Phone',
                  label: 'Phone',
                  className: 'form-col',
                  field: 'phone',
                  required: true,
                  requiredMessage: '',
                  invalidMessage: '',
                },
                {
                  type: 'TextArea',
                  label: 'Comments/Questions',
                  className: 'form-col-fluid',
                  placeholder: 'How can we help you?',
                  field: 'comments',
                  required: false,
                },
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

ContentSection.propTypes = {
  content: PropTypes.object.isRequired,
};

export default ContentSection;



// WEBPACK FOOTER //
// ./src/pages/ContactUs/ContentSection.js